import React, { useRef } from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string, node, oneOf } from 'prop-types'

import SmartTooltip from 'Pods/ItemPage/Components/SmartTooltip'

import useBreakpoint from 'Utils/useBreakpoint'

function DetailsAreaSmallTag({
  active = false,
  title,
  tooltip = null,
  place = null,
  autoPosition = false,
  containerSelector = null,
  quantity,
  tag,
}) {
  const breakpoint = useBreakpoint()
  const isMobile = ['xs', 'sm'].includes(breakpoint)
  const elementRef = useRef(null)

  const tagClasses = [
    'details-area__small-tag',
    active ? 'details-area__green_tag' : 'details-area__gray_tag',
  ].filter(Boolean).join(' ')

  const tagComponent = (
    <div ref={elementRef}>
      <TagComponent
        type="ghost"
        className={tagClasses}
      >
        {tag !== undefined ? (
          <a href={`/${title.toLowerCase()}-3d-models/${tag}`} className="details-area__tag-link">
            {title}
            {quantity && (
              <span className="details-area__tag-quantity">{`(${quantity})`}</span>
            )}
          </a>
        )
        : (
          <>
            {title}
            {quantity && (
              <span className="details-area__tag-quantity">{`(${quantity})`}</span>
            )}
          </>
        )}
      </TagComponent>
    </div>
  )

  if (tooltip) {
    return (
      <SmartTooltip
        content={tooltip}
        id={`tooltip-${title.toLowerCase().replace(/\s+/g, '-')}`}
        delayHide={100}
        delayUpdate={100}
        clickable
        place={place}
        autoPosition={autoPosition}
        containerSelector={containerSelector}
        disableMobileEvent
        globalEventOff={null}
        event={isMobile ? 'click' : ''}
      >
        {tagComponent}
      </SmartTooltip>
    )
  }

  return tagComponent
}

DetailsAreaSmallTag.propTypes = {
  active: bool,
  title: string.isRequired,
  tooltip: node,
  place: oneOf(['top', 'right', 'bottom', 'left']),
  autoPosition: bool,
  containerSelector: string,
  quantity: string,
  tag: string,
}

export default DetailsAreaSmallTag
